module.exports = __webpack_public_path__ + "images/rank-icon.svg";